var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/ehs_icon.png"),"alt":"eHealthcareIcon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }